var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433 72C384.648 23.649 324.38 0 256 0C187.619 0 123.331 26.629 74.98 74.98C26.628 123.332 0 187.62 0 256C0 324.38 26.628 388.667 74.98 437.019C123.332 485.371 187.619 512 256 512C324.38 512 388.667 485.371 437.019 437.019C485.371 388.667 512 324.38 512 256C512 187.62 481.352 120.353 433 72ZM256 500C131.383 500 14 380.617 14 256C14 131.383 131.383 12 256 12C380.617 12 499 131.383 499 256C499 380.617 380.617 500 256 500Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.004 188.392C375.147 182.536 365.649 182.536 359.792 188.393L227.334 320.852L157.606 251.125C151.749 245.268 142.251 245.268 136.393 251.125C130.536 256.982 130.536 266.48 136.393 272.338L216.726 352.671C219.655 355.6 223.494 357.064 227.332 357.064C231.17 357.064 235.01 355.599 237.938 352.671L381.004 209.605C386.862 203.748 386.862 194.25 381.004 188.392Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -4,
    y: 0,
    width: 520,
    height: 520,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.8b5cec12d63aa7065363fb72340ad75c.svg";
export { ForwardRef as ReactComponent };